import styled from '@emotion/styled'

import Mailbox from './Mailbox'

export default styled(Mailbox)`
  &&& {
    .email {
      color: ${props => props.theme.color.monochrome.superDark};
      font-size: ${props => props.theme.fontSize.small};
      font-weight: ${props =>
        props.theme.fontWeight.normal} !important; /* SUI override */
      margin-left: ${props => props.theme.spacing['3']};
    }
  }
`
